
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type garageRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function garageRT(): TemplateResult<garageRTRootProps> {
    return this.name !== 'HomeGarage' || this.isVehicleSelected ? _createElement('div', {
        'className': 'cm_garage' + (this.name === 'HomeGarage' ? ' cm_garage__home' : ''),
        'key': '0'
    }, _createElement('a', {
        'className': 'cm_toggle-dropdown garage-button navUser-text-wrapper',
        'title': 'Garage: ' + this.size + ' item(s)',
        'tabIndex': '0',
        'role': 'button'
    }, this.name === 'Garage' || this.name === 'MobileGarage' ? [
        [
            this.vehicleLogo ? _createElement('img', {
                'className': 'vehicle-logo',
                'src': this.vehicleLogo,
                'alt': this.vehicle.Make,
                'key': '4070'
            }) : null,
            !this.vehicleLogo ? _createElement('i', {
                'className': 'fas fa-car',
                'aria-hidden': 'true',
                'key': '4072'
            }) : null
        ],
        _createElement('span', {
            'className': 'garage-label',
            'key': '3093'
        }, !this.isVehicleSelected ? _translate(`garage_title`) : this.vehicleString)
    ] : null), [this.garageDropdown(function () {
            function repeatItems1(items, itemsIndex) {
                return [items(function () {
                        return _createElement('div', { 'className': 'garage-item' + (this.isSelected ? ' selected' : '') }, [
                            this.vehicleLogo ? _createElement('img', {
                                'className': 'vehicle-logo',
                                'src': this.vehicleLogo,
                                'alt': this.vehicle.Make,
                                'key': '970'
                            }) : null,
                            !this.vehicleLogo ? _createElement('i', {
                                'className': 'fas fa-car',
                                'aria-hidden': 'true',
                                'key': '972'
                            }) : null
                        ], _createElement('span', {
                            'className': 'select-model',
                            'onClick': this.selectVehicle
                        }, this.vehicleString), _createElement('span', {
                            'className': 'remove-model',
                            'onClick': this.removeVehicle
                        }, _createElement('i', {
                            'className': 'fas fa-trash',
                            'aria-hidden': 'true'
                        })));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'cm_garageDropdown' }, this.template === 'list' ? _createElement('div', {
                'className': 'cmTemplate_list',
                'key': '31'
            }, _createElement('div', { 'className': 'garage-content' }, [this.addButton(function () {
                    return _createElement('div', { 'className': 'add-vehicle  btn btn--primary cm_addButton' }, [
                        _createElement('i', {
                            'className': 'fas fa-plus',
                            'aria-hidden': 'true',
                            'key': '630'
                        }),
                        ' ',
                        _translate(`garage_add_vehicle`)
                    ]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })], _createElement.apply(this, [
                'div',
                { 'className': 'cmRepeater_items' },
                _map(this.items, repeatItems1.bind(this))
            ]))) : null, this.template === 'empty' ? _createElement('div', {
                'className': 'cmTemplate_empty',
                'key': '1686'
            }, _createElement('div', { 'className': 'garage-content' }, [this.addButton(function () {
                    return _createElement('div', { 'className': 'add-vehicle  btn btn--primary cm_addButton' }, [
                        _createElement('i', {
                            'className': 'fas fa-plus',
                            'aria-hidden': 'true',
                            'key': '630'
                        }),
                        ' ',
                        _translate(`garage_add_vehicle`)
                    ]);
                }, {
                    widgetName: 'undefined',
                    items: undefined
                })])) : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]) : null;
}
        export const componentNames = ["cm:addButton","cm:addButton","cm:garageDropdown"]